<template>
  <div :style="{ width: isIe }">
    <div class="daohang">
      <div class="flexs">
        <div class="class-name">
          <span class="span1"></span>
          <span class="span2">{{ classInfo.course_name }}</span>
        </div>
        <el-button v-if="classInfo.cate === 1" @click="edit" style="margin-right: 14px" type="primary" icon="el-icon-edit"
          size="small">编辑</el-button>

        <span>
          <span v-show="scflag" style="margin-right: 10px">
            <el-button v-if="classInfo.cate === 1" @click="upload" type="primary" icon="el-icon-upload2"
              size="small">上传</el-button>
          </span>
          <!-- <el-checkbox
            :indeterminate="isIndeterminate"
            v-model="checkAll"
            @change="handleCheckAllChange"
            >
            <el-button size="small" type="warning">全选</el-button>
            </el-checkbox
          > -->
          <el-button v-show="del_btn" size="small" type="warning" @click="delWriting"
            :disabled="del_list.length == 0">删除</el-button>
          <el-button v-show="del_btn" size="small" plain @click="cancel">取消</el-button>
        </span>
      </div>
      <div class="flexs">
        <el-select style="margin-right: 10px" v-model="classValue" placeholder="课程" size="small" @change="changeClass"
          v-if="classInfo.cate === 2">
          <el-option v-for="item in classInfo.courses" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
        <!-- <el-date-picker @change="changeData" size="small" v-model="value1" type="date" format="yyyy-MM-dd"
          value-format="yyyy-MM-dd" placeholder="请选择日期">
        </el-date-picker> -->
        <select-date :type="1" :course_id="classValue" @change-date="changeData"></select-date>
      </div>
    </div>

    <div class="writing flex">
      <div class="content" v-for="(item, index) in listData" :key="item.id">
        <el-checkbox-group v-if="checkFlag" v-model="checkedCities" @change="handleCheckedCitiesChange">
          <el-checkbox :label="item.id">
            <div></div>
          </el-checkbox>
        </el-checkbox-group>
        <div class="writing-div">
          <div class="writing-data" v-show="!del_btn" @click="writingDetail(item)">
            <img src="../../../assets/app_img/icon_vedio(1).png" alt="" />
            <span>{{ item.date }}</span>
          </div>
          <div class="classnames hide">
            <!-- {{item.name}}   @blur="changeName" -->
            <el-input v-if="quanxian" :ref="`editInput${index}`" v-model="item.name" @change="valueChange(item)"><i
                slot="suffix" class="el-icon-edit" style="line-height: 50px;color: #fff;"
                @click="editName(index)"></i></el-input>
            <span v-if="!quanxian">{{ item.name }}</span>
            <!-- <input type="text" :value="item.name" @blur="changeName(item)" style="background: none;
    border: none; color:#fff"> -->
          </div>
          <!-- <div class="imgdiv">
          </div> -->
          <img :src="item.image_url" @click="writingDetail(item)" alt="" />
        </div>
      </div>
    </div>
    <!-- 空状态 -->
    <el-empty :image-size="200" v-if="empty"></el-empty>
    <!-- 分页 -->
    <el-pagination v-if="pagination.totalPage > 1" background layout="prev, pager, next" :total="pagination.total"
      :current-page="pagination.page" @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :page-size="pagination.perPage">
    </el-pagination>
    <!-- 详情 -->
    <Detail ref="detail" :boardId="board_id"></Detail>
    <!-- 上传 -->
    <Upload ref="upload"></Upload>
  </div>
</template>

<script>
const cityOptions = ["上海", "北京", "广州", "深圳"]
import Detail from "./detail"
import Upload from "./upload.vue"
import { mapState } from 'vuex'
import SelectDate from '../../../components/filterComponent/SelectDate.vue'
export default {
  components: { Detail, Upload, SelectDate },
  data () {
    return {
      empty: false,
      pageFlag: true,
      scflag: true,
      quanxian: Boolean,
      // quanxian:window.localStorage.setItem("cate", res.data.cate),
      kechengName: "",
      classOptions: [],
      classValue: this.$store.state.classInfo.course_id,
      pagination: {},
      value1: '',
      msg: 123,
      flag: false,
      listData: [],
      dalogFlag: false,
      board_id: "",
      del_btn: false,
      checkedCities: [],
      cities: cityOptions,
      isIndeterminate: true,
      checkFlag: false,
      del_list: [],
      isIe: "",
      // cate: localStorage.getItem('cate'), //角色分类
    }
  },
  computed: {
    ...mapState({
      classInfo: state => state.classInfo
    })
  },
  watch: {
    'classInfo.id' (val, oldVal) {
      this.value1 = ''
      this.classValue = this.classInfo.course_id
      this.writingData()
    }
  },
  mounted () {
    if (!!window.ActiveXObject || "ActiveXObject" in window) {
      this.isIe = "1677px"
    } else {
      this.isIe = "100%"
    }
    if (window.localStorage.getItem("cate") == 1) {
      this.quanxian = true
    } else {
      this.quanxian = false
    }

    this.writingData()
    // 课程列表
    // this.changeClassName()
    // 获取课程名称
    // this.getClassName()
  },
  methods: {
    // async changeName(item) {

    //   const res = await this.$axios.post("/base/wake/update", {
    //     name: item.name,
    //     wake_id: item.id,
    //   });
    //   if (res.data.errCode == 0) {
    //     this.$message.success(res.data.message);
    //     this.writingData();
    //   } else {
    //     this.$message.error(res.data.message);
    //   }
    // },
    // 点击编辑按钮，输入框聚焦
    editName (index) {
      // console.log(this.$refs[`editInput${index}`])
      this.$refs[`editInput${index}`][0].focus()
    },
    // 数据发生变化
    async valueChange (item) {
      // console.log("change事件")
      const res = await this.$axios.post("/base/wake/update", {
        name: item.name,
        wake_id: item.id,
      })
      if (res.data.errCode == 0) {
        this.$message.success(res.data.message)
        this.writingData()
      } else {
        this.$message.error(res.data.message)
      }
    },
    // 分页
    handleSizeChange (val) {
      this.pagination.total = val
      this.writingData()
    },
    handleCurrentChange (val) {
      this.pagination.page = val
      this.writingData()
    },
    // 删除
    delWriting () {
      // console.log(this.del_list);
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.$axios
            .post("/base/wake/batch/del", {
              wake_ids: this.del_list,
            })
            .then((res) => {
              // console.log(res.data);
              if (res.data.errCode == 0 && res.status == 200) {
                // this.writingData();
                this.checkFlag = false
                this.del_btn = false
                this.writingData()
                this.scflag = true
                this.$message({
                  type: "success",
                  message: res.data.message,
                })
              } else {
                this.scflag = true
                this.$message({
                  type: "error",
                  message: res.data.message,
                })
              }
            })
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          })
        })
    },
    // 单选
    handleCheckedCitiesChange (value) {
      this.del_list = value
      // console.log(value);
      // for(let i = 0;i<value.length;i++){
      //   console.log(typeof value[i])
      // }
      // console.log(this.del_list.join())
      let checkedCount = value.length
      this.checkAll = checkedCount === this.cities.length
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.cities.length
    },
    // 全选
    handleCheckAllChange (val) {
      this.checkedCities = val ? cityOptions : []
      this.isIndeterminate = false
    },
    // 按日期选择微课
    changeData (val) {
      // console.log(this.value1);
      let date = val
      date !== null ? this.value1 = date : this.value1 = ''
      // this.value1 = date
      this.writingData()
      // const res = await this.$axios.post("/base/wake/date", {
      //   class_id: id,
      //   course_id: course_id,
      //   date: val,
      // })
      // if (res.status == 200 && res.data.errCode == 0) {
      //   if (res.data.data.length !== 0) {
      //     this.empty = false
      //     this.listData = res.data.data
      //   } else {
      //     this.pageFlag = false
      //     this.listData = []
      //     this.empty = true
      //   }
      //   // this.listData = res.data.data;
      //   // if(res.data.data.length == 0){
      //   //   this.listData = []
      //   //   this.pageFlag = false
      //   //   this.empty = true
      //   // }
      // } else {
      //   this.$message.error(res.data.message)
      // }
    },

    // 编辑
    edit () {
      this.del_btn = true
      // 控制删除radius
      this.checkFlag = true
      this.scflag = false
    },
    // 上传
    upload () {
      this.$refs.upload.uploadDialogVisible = true
      this.$refs.upload.jindutiao = false
      this.$refs.upload.progressPercent = 0
    },
    // 取消
    cancel () {
      this.del_btn = false
      this.checkFlag = false
      this.scflag = true
    },
    // 列表
    async writingData () {
      const { id } = this.classInfo
      const res = await this.$axios.post("/base/wake/list", {
        class_id: id,
        course_id: this.classValue,
        date: this.value1,
        page: this.pagination.page,
        perPage: this.pagination.perPage,
      })
      if (res.status == 200 && res.data.errCode == 0) {
        // console.log(res);
        if (res.data.data.length == 0) {
          this.empty = true
          this.pageFlag = false
        } else {
          this.empty = false
        }
        this.listData = res.data.data
        this.pagination = res.data.meta.pagination
        // console.log(this.listData);
      } else {
        this.$message.error(res.data.message)
      }
    },
    // 详情
    writingDetail (item) {
      // console.log(item);
      // return
      this.board_id = item.id
      // console.log(this.board_id);
      this.dalogFlag = true
      this.$refs.detail.imgs = item.video_url
      this.$refs.detail.dialogVisible = true
      // this.$refs.detail.writingDetail();
    },
    // 课程列表数据
    // async changeClassName () {
    //   const res = await this.$axios.post("/base/class/courses", {
    //     class_id: window.localStorage.getItem("class_id"),
    //   })
    //   if (res.status == 200 && res.data.errCode == 0) {
    //     // console.log(res.data.data);
    //     this.classOptions = res.data.data
    //   } else {
    //     this.$message.error(res.data.message)
    //   }
    // },
    // 获取当前课程名称
    // async getClassName () {
    //   const res = await this.$axios.post("/base/class/choose", {
    //     class_id: window.localStorage.getItem("class_id"),
    //     course_id: window.localStorage.getItem("course_id"),
    //   })
    //   if (res.status == 200 && res.data.errCode == 0) {
    //     this.kechengName = res.data.data.course_name
    //   } else {
    //     this.$message.error(res.data.message)
    //   }
    // },
    // 选择课程
    changeClass (id) {
      this.classValue = id
      // window.localStorage.setItem("course_id", id)
      // 列表数据
      this.writingData()
      // 课程列表
      // this.changeClassName()
      // 获取课程名称
      // this.getClassName()
    },
  },

}
</script>

<style lang="scss" scoped>
/deep/ .el-checkbox__input {
  position: absolute;
  top: -10px;
  right: -289px;
  border-radius: 50%;
}

/deep/ .el-checkbox-group {
  position: absolute;
}

/deep/ .el-checkbox__inner::after {
  height: 15px;
  left: 8px;
}

/deep/ .el-checkbox__input.is-checked .el-checkbox__inner {
  background: #e6a23c;
  border-color: #e6a23c;
}

/deep/ .el-checkbox__input.is-focus .el-checkbox__inner {
  border-color: #e6a23c;
}

/deep/ .el-checkbox__inner {
  border-radius: 50%;
  width: 24px;
  height: 24px;
}

/deep/ .el-checkbox__inner:hover {
  border-color: #e6a23c;
}

.flexs {
  display: flex;
  // justify-content: space-between;
}

.class-name {
  display: flex;
  margin-top: 4px;
  // display: inline-block;

  // display: flex;
  .span1 {
    display: inline-block;
    width: 6px;
    height: 6px;
    background: #da6013;
    border-radius: 50%;
    margin-right: 8px;
    margin-top: 8px;
    vertical-align: center;
  }

  .span2 {
    display: inline-block;
    // margin-right: 34px;
    vertical-align: center;
    font-weight: 600;
    width: 80px;
  }
}

.daohang {
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #d8e2eb;
  margin-bottom: 20px;
}

.flex {
  display: flex;
  flex-flow: wrap;
}

.writing {
  margin-right: 15px;
  margin-bottom: 15px;

  .content:hover {
    box-shadow: 0 0.188679rem 0.113208rem 0 #d8e2eb;
  }

  .content {
    width: 290px;
    height: 196px;
    position: relative;
    margin: 0 15px 15px 0;
    padding: 9px;
    background: #fff;
    border-radius: 8px;
  }

  .writing-div {
    width: 290px;
    height: 195px;
    position: relative;

    .classnames {
      // height: 50px;
      background-image: linear-gradient(to bottom,
          rgba(0, 0, 0, 0),
          rgba(0, 0, 0, 0.5));
      position: absolute;
      bottom: 0px;
      padding: 0 12px;
      box-sizing: border-box;
      width: 100%;
      color: #fff;
      font-size: 14px;

      /deep/ .el-input__inner {
        height: 50px;
        background: none;
        border: none;
        color: #fff;
        padding: 0;
      }
    }

    .writing-data {
      background-image: linear-gradient(to top,
          rgba(0, 0, 0, 0),
          rgba(0, 0, 0, 0.5));
      font-size: 14px;
      position: absolute;
      // top: 10px;
      padding: 12px 12px;
      box-sizing: border-box;
      width: 100%;
      height: 50px;
      display: flex;
      justify-content: space-between;
      color: #fff;
      // opacity: 0.6;
      display: flex;
      justify-items: center;
      justify-content: flex-start;

      span {
        line-height: 20px !important;
        display: inline-block;
      }

      img {
        margin-right: 10px;
        width: 20px;
        height: 20px;
        line-height: 20px !important;
        display: inline-block;
      }
    }

    .writing-list {
      margin-top: 6px;
      height: 57px;
      display: flex;
      justify-content: space-between;

      img {
        display: block;
        height: 57px;
        width: 92px;
      }
    }
  }

  position: relative;

  img {
    width: 100%;
    height: 100%;
    // border-radius: 8px;
    // background-image: linear-gradient(0deg, rgba(0, 0, 0, 0.4) 0%, #000000 100%);
    box-shadow: rgba(0, 0, 0, 0.4) 0% 0px 0px 30px 5px inset;
  }

  .imgdiv {
    // position: relative;
    width: 100%;
    height: 100%;
  }
}

.hide {
  width: 250px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  span {
    display: block;
    margin-bottom: 14px;
  }
}

/deep/ .el-input__icon {
  // color: #fff;
}

/deep/ .el-icon-date {
  color: #C0C4CC;
}
</style>



// WEBPACK FOOTER //
// src/view/Panel/weike/index.vue